<h1>Welcome to the Applicant Tracking System!</h1>

<div class="mb-4">
  <ul>
    <li class="mb-2">To begin the application, please click "Applicant" (located in the top left corner) then "Applications" from the drop-down selection.</li>
    <li class="mb-2">Utilize the modern web browsers (Google Chrome/ Edge) for completing this application. </li>
    <li class="mb-2">Should you experience delays or the application freezing, please refresh your browser. If refreshing does not resolve the issue, please log out and log back in.</li>
    <li class="mb-2">Ensure you have all forms requiring a notary’s signature signed and notarized (we are unable to notarize any of the forms for you). Also, ensure you have ALL requested forms and documents completed and upload them to the task section of your application. Failure to have all forms and notarizations completed could result in your affidavit being placed in an inactive status.</li>
    <li class="mb-2">
      MAIL ALL SEALED OFFICIAL COLLEGE TRANSCRIPTS TO THE FOLLOWING ADDRESS:
      <br />
      <span style="padding-left: 20px; display:block">
        Florida Highway Patrol<br />
        Background, Recruitment and Selection<br />
        2900 Apalachee Parkway, MS 49<br />
        Tallahassee, FL 32399
      </span>
    </li>
    <li class="mb-2">
      Prior to attending your scheduled PAT Testing, you MUST visit your physician (Medical Doctor) and have the Florida Highway Patrol Medical Release Form completed by your physician. A   Licensed Practical Nurse, or equivalent, completing this form will NOT satisfy the requirement of your clearance by a Medical Doctor.
    </li>
    <li class="mb-2">
      You will need to take and pass the Criminal Justice Basic Abilities Test (CJBAT) for Law Enforcement Officer. You will not be assigned to a Background Investigator until your CJBAT results have been received. You must provide proof through email to BeATrooper@flhsmv.gov of a passing score. The Florida Highway Patrol DOES NOT administer this test. The CJBAT (or FBAT) must be scheduled and paid by you.
      <div class="my-2">
        <ul>
          <li>
            Former Florida-certified or out-of-state-certified officers may qualify for an exemption from the CJBAT. Any applicant with an associate degree or higher from an accredited college OR a U.S. veteran discharged or released under honorable conditions is exempt from the CJBAT. If you have taken and passed the CJBAT for Law Enforcement Officer within the last four (4) years, or if you are certified as a law enforcement officer in the State of Florida, you will not need to retake the CJBAT. More information about this test, study materials, and where the test is administered can be found at the following website:
            <div class="mt-2">
              <a target="_blank" href="http://www.fdle.state.fl.us/CJSTC/Officer-Requirements/Basic-Abilities-Test.aspx">http://www.fdle.state.fl.us/CJSTC/Officer-Requirements/Basic-Abilities-Test.aspx</a>
            </div>
          </li>
        </ul>
      </div>
    </li>

  </ul>
  <div class="d-flex justify-content-center">Best of luck as you begin your journey to become one of Florida’s Finest!</div>
</div>
<!--<div class="row mb-4">
  <div class="col-sm-4 offset-sm-4">
    <iframe width="420" height="315" [src]='safeUrl' frameborder="0" allowfullscreen></iframe>
  </div>
</div>-->

<div class="row mb-4">
  <div class="col-sm-4 offset-sm-4">
    <vg-player>
      <video [vgMedia]="media" #media id="singleVideo" poster="assets/images/logo-intro-still.jpg" preload="auto" controls>
        <source [attr.src]="getVideoURL('BRS BITS Intro','mp4')" type="audio/mp4" />
      </video>
    </vg-player>
  </div>
</div>
